<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Objeto Ação</h3>
      </div>
    </div>
    <ObjetoAcaoaAdd v-if="showAdd" ref="ObjetoAcaoaAdd" v-on:Back="onBack" />
    <ObjetoAcaoList v-else ref="ObjetoAcaoList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ObjetoAcaoaAdd from './components/add/objetoacaoadd.vue'
import ObjetoAcaoList from './components/list/objetoacaolist.vue'

export default {
  name: 'Comarca',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ObjetoAcaoaAdd,
    ObjetoAcaoList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ObjetoAcaoaAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/objetoacao/objetoacao.vue